import { HubFeature } from '@ats/api/cm';
import { LocDefs, MapLocKeys } from '@cm/core/localization';
import { candExamsDPRoot } from '@cm/feature/exam';

const dpRoot = `${candExamsDPRoot}|Candidate Exam Card`;

export type SPCandExamCardLoc = 'SPCandExamCardExamCode' | 'SPCandExamCardRegNumber';

export const spCandExamCardLocs: LocDefs<SPCandExamCardLoc> = {
	SPCandExamCardExamCode: {
		defaultValue: 'Exam Code',
		description: 'Candidate exam card section for exam code.',
		displayPath: `${dpRoot}|Exam Code`,
		displayType: 'Content',
		feature: HubFeature.Exam,
		portal: 'SP',
	},
	SPCandExamCardRegNumber: {
		defaultValue: 'Registration Number',
		description: 'Candidate exam card section for registration number.',
		displayPath: `${dpRoot}|Registration Number`,
		displayType: 'Content',
		feature: HubFeature.Exam,
		portal: 'SP',
	},
};

export const LOC_KEYS = MapLocKeys<SPCandExamCardLoc>(spCandExamCardLocs);
